import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';

import { routes } from './app.routes';
import { providePrimeNG } from 'primeng/config';
import { BInclusionTheme } from '../themes/binclusion.theme';
import { AuthService } from './core/services/auth.service';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { DialogService } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { paginationMapInterceptor } from './core/interceptors/pagination-map-interceptor';
import { httpErrorInterceptor } from './core/interceptors/error-interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(() => {
      const authService = inject(AuthService);
      return authService.getInfoFromLocalStorage();
    }),
    provideHttpClient(
      withInterceptors([authInterceptor, paginationMapInterceptor, httpErrorInterceptor])
    ),
    provideBrowserGlobalErrorListeners(),

    provideRouter(routes, withComponentInputBinding()),
    providePrimeNG({
      theme: {
        preset: BInclusionTheme,
        options: {
          darkModeSelector: '.dark',
        },
      },
    }),
    DialogService,
    MessageService,
  ],
};
